import Vue from 'vue'
import Router from 'vue-router'
import Happy from '@/pages/Happy/Happy.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Happy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js